import { Grid, IconButton, Tooltip } from '@mui/material'
import { useEffect, useState } from 'react'
import { MdAdd, MdOutlineFileDownload } from 'react-icons/md'
import { PiFilePdfDuotone } from 'react-icons/pi'
import Programa from '../../../components/Programa/Programa'
import PrimeTable from '../../../components/PrimeTable'
import ModalNotaFiscal from './ModalNotaFiscal'
import ModalVisualizaDocumento from './ModalVisualizaDocumento'
import { metodoPrograma } from '../../../components/api'
import { setError } from '../../../components/alerts'

const CtrlNotaFiscal = () => {
  const [openModal, setOpenModal] = useState(false)
  const [refresh, setRefresh] = useState(0)
  const [ferramentas, setFerramentas] = useState()
  const [loading, setLoading] = useState(false)
  const [modalVisualizaArquivo, setModalVisualizaArquivo] = useState(false)
  const [dsToken, setDsToken] = useState(undefined)

  const downloadXMLFromText = (xmlText, fileName) => {
    const blob = new Blob([xmlText], { type: 'application/xml;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }

  const handleDownloadXml = async (e, row) => {
    e.stopPropagation()
    setLoading(true)
    const res = await metodoPrograma('downloadXML', {
      idNotaFiscal: row?.[0],
    })
    if (res?.status) {
      downloadXMLFromText(res.xml, `NFSe-${row?.[0]}.xml`)
    } else {
      setError(res?.dsErro || 'Erro ao baixar o XML.')
    }
    setLoading(false)
  }

  const handleVisualizaPdf = async (e, row) => {
    e.stopPropagation()
    setLoading(true)
    const res = await metodoPrograma('downloadPDF', {
      idNotaFiscal: row?.[0],
    })
    if (res?.status) {
      setDsToken(res.dsToken)
      setModalVisualizaArquivo(true)
    } else {
      setError(res?.dsErro || 'Erro ao abrir o PDF.')
    }
    setLoading(false)
  }

  useEffect(() => {
    setFerramentas(
      <Tooltip title="Emitir Nota Fiscal">
        <span>
          <IconButton onClick={() => setOpenModal(true)} disabled={loading}>
            <MdAdd />
          </IconButton>
        </span>
      </Tooltip>,
    )
  }, [loading])

  return (
    <Programa codigo="CtrlNotaFiscal" ferramentas={ferramentas}>
      <ModalNotaFiscal
        open={openModal}
        handleClose={() => setOpenModal(false)}
        setRefresh={setRefresh}
      />

      <ModalVisualizaDocumento
        dados={dsToken}
        show={modalVisualizaArquivo}
        handleClose={() => {
          setModalVisualizaArquivo(false)
          setDsToken(undefined)
        }}
      />

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <PrimeTable
            codigo="CtrlNotaFiscal"
            action="lista"
            rows={10}
            habSearch
            refresh={refresh}
            head={[
              '#',
              'Empresa',
              'Paciente',
              'Atendimento',
              'Valor',
              'Emissão',
              '',
            ]}
            collumnsDateHour={[5]}
            collumnsCurrency={[4]}
            line={(item) => [
              item?.[0],
              item?.[1]?.[1] ?? item?.[1] ?? '',
              item?.[2]?.[1] ?? item?.[2] ?? '',
              item?.[8]?.[1] ?? '',
              item?.[5] ?? '',
              item?.[6] ?? '',
              '',
            ]}
            columnOptions={[
              {
                alias: 6,
                customJsx: ({ linhaOriginal }) => (
                  <>
                    <Tooltip title="Download XML">
                      <IconButton
                        size="small"
                        onClick={(e) => handleDownloadXml(e, linhaOriginal)}
                      >
                        <MdOutlineFileDownload size={20} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Visualizar PDF">
                      <IconButton
                        size="small"
                        onClick={(e) => handleVisualizaPdf(e, linhaOriginal)}
                      >
                        <PiFilePdfDuotone size={20} />
                      </IconButton>
                    </Tooltip>
                  </>
                ),
              },
            ]}
          />
        </Grid>
      </Grid>
    </Programa>
  )
}

export default CtrlNotaFiscal
